export default __webpack_public_path__ + "static/apple-touch-icon-523b61294d4384b46ddaf22b8eab2a35.png";